import { ShopUsersApiClient } from '@fourthwall/services/dist/ShopUsersApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useShopGroupStatsQuery = createQueryHook(ShopUsersApiClient.getShopGroupStats, {
  queryKey: ['shopGroupStats'],
})
